module.exports = __webpack_public_path__ + "3ef0dfc422ab657fbe8182c4c8cbbfae.png";